import { gEnums } from "global/enums/globalEnums";
import { createRefPath_client, createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import { SportsDataContext } from "projectSpecific/sports/cnr/contexts/SportsDataContext";
import { useContext, useEffect, useState } from "react";
import { AppComponentContext } from "../AppComponentContext";
import { DatabaseContext } from "../DatabaseContext";
import { _showAppLogs } from "../LogContext";
import { ParentContext } from "../ParentContext";
import { useDataConditionals } from "./useDataConditionals";
import { PageAreaContext } from "../PageAreaContext";

export const useItemData = ({ dataInit_state }) => {

  const { viewItem, uivi } = dataInit_state ?? {}

  const { getFilteredData } = useDataConditionals({ dataInit_state })

  // parentContexts
  const parentContexts = useContext(ParentContext)
  const { states, handlers } = parentContexts ?? {}
  const { homeInfo_state, clientInfo_state, eventInfo_state } = states ?? {}
  const { log_handlers } = handlers

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageData } = pageArea_state ?? {}

  // eventInfo_state
  const { appDataDocuments } = eventInfo_state ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  // states
  const { pathViews, nonLandingView, view, viewKey: dataCollectionItemKey } = _.get(states, 'paps_state', {});
  const { events: eventKey, clients: clientKey } = pathViews ?? {}
  const _isClient = pathViews?.clients ? true : false
  const _isEvent = pathViews?.clients && pathViews?.events ? true : false

  const { dataSource } = viewItem ?? {}
  const { dataCollectionName, dataSourceType } = dataSource ?? {}

  const appDataDocument = appDataDocuments?.[dataCollectionName]
  const _appDataDocument = pageData?.[uivi]?.data

  let trueUivi = uivi;

  if (dataCollectionName !== uivi) {
    trueUivi = dataCollectionName
  }
  const [itemDataInfo, setItemDataInfo] = useState()

  const sportsDataContext = useContext(SportsDataContext)
  const { sportsData_state } = sportsDataContext ?? {}

  const golfEventContext = useContext(AppComponentContext)
  const { golfEvent_state } = golfEventContext ?? {}

  useEffect(() => {

    let cache_groupType = 'homeInfo';
    let cache_key = 'homeInfo';
    let storageKey;
    let _storageDocKey;
    let _isSingleDataItemm = dataCollectionItemKey && (nonLandingView === uivi)

    if (_isEvent) {
      cache_groupType = 'eventInfo'
      cache_key = eventKey
      storageKey = `eventInfo-${eventKey}-appDataDocuments`
      _storageDocKey = `eventInfo-${eventKey}-documents-${dataCollectionName}`
    } else if (_isClient) {
      cache_groupType = 'clientInfo'
      cache_key = clientKey
      if (_isSingleDataItemm) {
        storageKey = `appInfo-clients`
      } else {
        storageKey = `clientInfo-${clientKey}-clientEvents`
      }
    } else {
      cache_groupType = 'homeInfo'
      cache_key = clientKey
      storageKey = `appInfo-clients`
    }

    const _uivi = dataCollectionName || uivi
    let _isSingleDataItem = dataCollectionItemKey && (view === uivi) && (_uivi === uivi)


    const cbData = (data) => {
      // console.group('DATA', uivi)
      // if (pageData?.[uivi]) {
      //   console.log('pageData', pageData?.[uivi]?.count, pageData?.[uivi]?.data)
      // }
      // console.log('itemData', _.size(data), data)
      // console.groupEnd()
      setItemDataInfo({ itemData: data, itemDataName: _uivi })
    }

    const getHomeData = async () => {
      if (homeInfo_state?.[trueUivi]) {
        cbData(homeInfo_state?.[trueUivi])
      }
    }

    const getClientData = async () => {
      if (clientInfo_state?.[trueUivi]) {
        cbData(clientInfo_state?.[trueUivi])
        return;
      }

      const cb_client = async (fetchedData) => {
        _showAppLogs.dbFetch && log_handlers.addLog(`🌐💾 Fetched data(${dataCollectionName}) from Firebase`);
        console.log('fetchedData', dataCollectionName, fetchedData)
        const dataState = {
          viewItem: dataCollectionName,
          uivi: dataCollectionName
        }
        getFilteredData(fetchedData, cbData, dataState)
      };

      getData_collection(database_fns, _isEvent, _isClient, dataCollectionName, pathViews, trueUivi, cbData, cb_client)
    }

    const getEventData = async () => {

      if (!appDataDocuments) {
        _showAppLogs.dbFetch && log_handlers.addLog(`⚠️ No appDataDocuments. Looking for ${dataCollectionName}`);
        _showAppLogs.dbFetch && log_handlers.addLog(`⚠️ ${appDataDocuments}`);
      }

      const fromCache = 'cache'

      // if _appDataDocument found, return it
      if (_appDataDocument) {
        cbData(_appDataDocument)
        return;
      }

      // if appDataDocument found, return it
      if (appDataDocument) {
        if (_isSingleDataItem) {
          const _itemData = {
            [dataCollectionItemKey]: appDataDocument?.[dataCollectionItemKey]
          }
          _showAppLogs.itemData && log_handlers.addLog(`♻️💾 Loaded item data (${dataCollectionName}-${dataCollectionItemKey}) from ${fromCache}`);
          cbData(_itemData)
          return;
        }
        _showAppLogs.itemData && log_handlers.addLog(`♻️💾 Loaded collection data (${dataCollectionName})(${_.size(appDataDocument)}) from ${fromCache}`);
        getFilteredData(appDataDocument, cbData)
        return;
      }

      // 2️⃣ Listen for Firestore updates
      const cb_event = async (fetchedData) => {
        _showAppLogs.dbFetch && log_handlers.addLog(`🌐💾 Fetched data(${dataCollectionName}) from Firebase`);
        getFilteredData(fetchedData, cbData)
      };

      getData_collection(database_fns, _isEvent, _isClient, dataCollectionName, pathViews, trueUivi, cbData, cb_event)

    }

    const getData = async () => {
      // const {   fromDocCache } = await getCachedData()

      if (_isEvent) {
        getEventData()
      } else if (_isClient) {
        getClientData()
      } else {
        getHomeData()
      }
    }

    switch (dataSourceType) {
      case gEnums.dataSourceTypes.component:
        cbData({})
        break;
      case gEnums.dataSourceTypes.googleSheet:
        cbData({})
        break;
      case gEnums.dataSourceTypes.none:
        cbData({})
        break;
      default:
        getData()
    }

  }, [trueUivi, pathViews, appDataDocument, pageData]);

  return { itemDataInfo };
};

const getData_collection = (database_fns, _isEvent, _isClient, dataCollectionName, pathViews, trueUivi, cbData, cb) => {
  try {
    let refPath;
    if (_isEvent && trueUivi) {
      // get the data from the event root
      refPath = createRefPath_event(pathViews, [trueUivi])
    } else if (_isClient && trueUivi) {
      // get the data from the client root
      refPath = createRefPath_client(pathViews, [trueUivi])
    } else {
      // get the data from the root
      cbData({})
    }
    if (refPath) {
      database_fns.get_data({
        refPath,
        callback: cb,
        opts: { listen: true },
      });
    }
  } catch (err) {
    _showAppLogs.dbFetch && log_handlers.addLog(`❌💾 Failed to fetch data${dataCollectionName}`, err);
  }
}